var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjections({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.67 20.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.94,9.79c.33,.44,.24,1.07-.21,1.4l-2.89,2.14c-.18,.13-.39,.2-.6,.2s-.42-.07-.6-.2l-5.3-3.93-2.2,1.69c-.44,.34-1.07,.25-1.4-.19-.34-.44-.25-1.07,.19-1.4l2.8-2.15c.35-.27,.85-.28,1.2,0l5.31,3.94,2.29-1.7c.45-.33,1.07-.24,1.4,.21Zm3.73-6.63v14.35c0,1.74-1.42,3.16-3.16,3.16H3.16c-1.74,0-3.16-1.42-3.16-3.16V3.16C0,1.42,1.42,0,3.16,0h14.35c1.74,0,3.16,1.42,3.16,3.16Zm-2,0c0-.64-.52-1.16-1.16-1.16H3.16c-.64,0-1.16,.52-1.16,1.16v14.35c0,.64,.52,1.16,1.16,1.16h14.35c.64,0,1.16-.52,1.16-1.16V3.16Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjections);
export default __webpack_public_path__ + "static/media/projections.b8d21268a5abf84cb1c11afaae147da5.svg";
export { ForwardRef as ReactComponent };